import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import Service from "../../service";
import { GLOBAL_CONFIG } from "../../constants/permission_id";

const API_URL =
  `${process.env.REACT_APP_API_URL}/uploads/company_image`;

const SidebarLogo = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { width, themeType } = useSelector(({ settings }) => settings);
  const { authUser } = useSelector(({ auth }) => auth);
  const [sideBarlogo, setSideBarlogo] = useState();
  const LogoAction = useSelector((state) => state.common);
  const companySlug = localStorage.getItem("companyDomain");

  const [logoFromStorage, setLogoFromStorage] = useState(
    localStorage.getItem(`LogoUrl_${companySlug}`)
  );

  useEffect(() => {
    getAdminListLogo();
  }, [LogoAction.logo, logoFromStorage]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === `LogoUrl_${companySlug}` || e.key === null) {
        setLogoFromStorage(localStorage.getItem(`LogoUrl_${companySlug}`));
      }
    };

    window.addEventListener("storage", handleStorageChange);

    const handleCustomStorageChange = (e) => {
      if (e.detail.key === `LogoUrl_${companySlug}`) {
        setLogoFromStorage(e.detail.newValue);
      }
    };

    window.addEventListener("localStorageChange", handleCustomStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener(
        "localStorageChange",
        handleCustomStorageChange
      );
    };
  }, [companySlug]);

  const getAdminListLogo = async () => {
    try {
      const params = `/${authUser?._id}`;
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.adminSetting + params,
      });
      if (response.data?.data?.config?.adminSetting?.logo) {
        setSideBarlogo(response.data.data.config.adminSetting.logo);
      } else {
        if (LogoAction.logo) {
          setSideBarlogo(LogoAction.logo);
        } else if (logoFromStorage) {
          setSideBarlogo(logoFromStorage);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  let navStyle = useSelector(({ settings }) => settings.navStyle);
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }
  return (
    <div className="gx-layout-sider-header sidebar_main">
      {navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR ? (
        <div className="gx-linebar hemmenu"></div>
      ) : null}

      <Link
        to={
          authUser?.emp_code
            ? `/${companySlug}/dashboard`
            : `/${companySlug}/dashboard`
        }
        className="gx-site-logo"
      >
        {sideBarlogo ? (
          <img
            alt=""
            src={
              sideBarlogo.startsWith("http")
                ? sideBarlogo
                : `${API_URL}/${sideBarlogo}`
            }
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = GLOBAL_CONFIG.LOGO_WHITE; }}
          />
        ) : logoFromStorage ? (
          <img alt="" src={`${API_URL}/${logoFromStorage}`} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = GLOBAL_CONFIG.LOGO_WHITE; }} />
        ) : navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR &&
          width >= TAB_SIZE ? (
          <img alt="lo" src={require("assets/images/fav.ico")} />
        ) : themeType === THEME_TYPE_LITE ? (
          <img alt="logo1" src={GLOBAL_CONFIG.LOGO_WHITE} />
        ) : (
          <img alt="logo2" src={GLOBAL_CONFIG.LOGO_WHITE} />
        )}
      </Link>
    </div>
  );
};

export default SidebarLogo;
